import { render, staticRenderFns } from "./PostModalOffer.vue?vue&type=template&id=60685b8f&scoped=true&"
import script from "./PostModalOffer.vue?vue&type=script&lang=js&"
export * from "./PostModalOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60685b8f",
  null
  
)

export default component.exports